import { DiscriminatorElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Discriminator extends DiscriminatorElement {
  /**
   * OpenAPI 3.2: Default schema mapping to use when discriminator value doesn't match any mapping.
   */
  get defaultMapping() {
    return this.get('defaultMapping');
  }
  set defaultMapping(defaultMapping) {
    this.set('defaultMapping', defaultMapping);
  }
}
export default Discriminator;